import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum SaleTypeId {
  PRO = 1,
  LITE = 2,
  CONNECT = 3,
  COMMUNICATION = 4,
  MINUTE_RESERVATION = 30,
  CHM = 5,
  IBE = 6,
  AGENCY = 7,
  GOOGLE_HOTEL_SEARCH = 8,
  ALFRED = 9,
  ALFRED_CHECK_IN = 10,
  ALFRED_SERVICE = 11,
  ALFRED_CLEANING = 12,
  ALFRED_SMS_FEE = 13,
  ALFRED_SMS_INTERNATIONAL = 14,
  ALFRED_DOOR_LOCK_OR_PIN = 15,
  HOUSEKEEPING_APP = 16,
  SCANID_APP = 17,
  AI_CHATBOT = 18,
  CONNECTOR_TO_PAYMENT_TERMINAL = 19,
  CONNECTOR_TO_PAYMENT_GATEWAY = 20,
  CONNECTOR_TO_PAYMENT_TERMINAL_AND_GATEWAY = 21,
  CONNECTOR_TO_3RD_PARTY_CHM_OR_IBE = 22,
  CONNECTOR_TO_ALL_OTHER_SWS = 23,
  TRAINING = 24,
  PREVIO_OFFICE_OR_ONLINE = 25,
  AT_THE_CLIENT = 26,
  WEBSITE = 27,
  TEMPLATE = 28,
  INDIVIDUAL = 29,
  PMS = 31,
  ALFRED_GROUP = 32,
  CONNECTOR_PAYMENTS = 33,
}

export class SaleType extends Codebook<SaleTypeId> {
  static readonly PRO = new SaleType(SaleTypeId.PRO, () => $t('PRO license'), 'PRO')
  static readonly LITE = new SaleType(SaleTypeId.LITE, () => $t('PMS - LITE license'), 'LITE')
  static readonly CONNECT = new SaleType(SaleTypeId.CONNECT, () => $t('Connect license'), 'CONNECT')
  static readonly COMMUNICATION = new SaleType(
    SaleTypeId.COMMUNICATION,
    () => $t('Communication'),
    'COMM',
  )
  static readonly CHM = new SaleType(SaleTypeId.CHM, () => $t('CHM'), 'CHM')
  static readonly IBE = new SaleType(SaleTypeId.IBE, () => $t('IBE'), 'IBE')
  static readonly AGENCY = new SaleType(SaleTypeId.AGENCY, () => $t('Agency / owner'), 'AGENCY')
  static readonly GOOGLE_HOTEL_SEARCH = new SaleType(
    SaleTypeId.GOOGLE_HOTEL_SEARCH,
    () => $t('Google Hotel Search'),
    'GHS',
  )
  static readonly ALFRED = new SaleType(
    SaleTypeId.ALFRED,
    () => $t('Alfred (flat fee + SMS + PIN)'),
    'ALFRED',
  )
  static readonly ALFRED_CHECK_IN = new SaleType(
    SaleTypeId.ALFRED_CHECK_IN,
    () => $t('Alfred - check-in'),
    'ALFREDCHECKIN',
  )
  static readonly ALFRED_SERVICE = new SaleType(
    SaleTypeId.ALFRED_SERVICE,
    () => $t('Alfred - service'),
    'ALFREDSERVICE',
  )
  static readonly ALFRED_CLEANING = new SaleType(
    SaleTypeId.ALFRED_CLEANING,
    () => $t('Alfred - cleaning'),
    'ALFREDCLEANING',
  )
  static readonly ALFRED_SMS_FEE = new SaleType(
    SaleTypeId.ALFRED_SMS_FEE,
    () => $t('Alfred - SMS fee'),
    'ALFREDSMS',
  )
  static readonly ALFRED_SMS_INTERNATIONAL = new SaleType(
    SaleTypeId.ALFRED_SMS_INTERNATIONAL,
    () => $t('Alfred - SMS international'),
    'ALFREDSMSINT',
  )
  static readonly ALFRED_DOOR_LOCK_OR_PIN = new SaleType(
    SaleTypeId.ALFRED_DOOR_LOCK_OR_PIN,
    () => $t('Alfred - door lock or PIN'),
    'ALFREDLOCK',
  )

  static readonly HOUSEKEEPING_APP = new SaleType(
    SaleTypeId.HOUSEKEEPING_APP,
    () => $t('Housekeeping app'),
    'HSKAPP',
  )
  static readonly SCANID_APP = new SaleType(
    SaleTypeId.SCANID_APP,
    () => $t('ScanID app'),
    'SCANIDAPP',
  )
  static readonly AI_CHATBOT = new SaleType(SaleTypeId.AI_CHATBOT, () => $t('AI Chatbot'), 'AICHAT')
  static readonly CONNECTOR_TO_PAYMENT_TERMINAL = new SaleType(
    SaleTypeId.CONNECTOR_TO_PAYMENT_TERMINAL,
    () => $t('Connector to payment terminal'),
    'CONNPAYTERM',
  )
  static readonly CONNECTOR_TO_PAYMENT_GATEWAY = new SaleType(
    SaleTypeId.CONNECTOR_TO_PAYMENT_GATEWAY,
    () => $t('Connector to payment gateway'),
    'CONNPAYGW',
  )
  static readonly CONNECTOR_TO_PAYMENT_TERMINAL_AND_GATEWAY = new SaleType(
    SaleTypeId.CONNECTOR_TO_PAYMENT_TERMINAL_AND_GATEWAY,
    () => $t('Connector to payment terminal and gateway'),
    'CONNPAYTERMGW',
  )
  static readonly CONNECTOR_TO_3RD_PARTY_CHM_OR_IBE = new SaleType(
    SaleTypeId.CONNECTOR_TO_3RD_PARTY_CHM_OR_IBE,
    () => $t('Connector to 3rd party CHM or IBE'),
    'CONN3RDCHMIBE',
  )
  static readonly CONNECTOR_TO_ALL_OTHER_SWS = new SaleType(
    SaleTypeId.CONNECTOR_TO_ALL_OTHER_SWS,
    () => $t('Connector to all other SWs'),
    'CONNOTHERSW',
  )
  static readonly TRAINING = new SaleType(SaleTypeId.TRAINING, () => $t('Training'), 'TRAINING')
  static readonly PREVIO_OFFICE_OR_ONLINE = new SaleType(
    SaleTypeId.PREVIO_OFFICE_OR_ONLINE,
    () => $t('Previo office or online'),
    'TRAININGONL',
  )
  static readonly AT_THE_CLIENT = new SaleType(
    SaleTypeId.AT_THE_CLIENT,
    () => $t('At the client'),
    'TRAININGCLIENT',
  )
  static readonly WEBSITE = new SaleType(SaleTypeId.WEBSITE, () => $t('Website'), 'WEBSITE')
  static readonly TEMPLATE = new SaleType(SaleTypeId.TEMPLATE, () => $t('Template'), 'TEMPLATE')
  static readonly INDIVIDUAL = new SaleType(
    SaleTypeId.INDIVIDUAL,
    () => $t('Individual'),
    'INDIVIDUAL',
  )
  static readonly MINUTE_RESERVATION = new SaleType(
    SaleTypeId.MINUTE_RESERVATION,
    () => $t('Minute reservation'),
    'MINUTE_RESERVATION',
  )
  static readonly PMS = new SaleType(SaleTypeId.PMS, () => $t('PMS'), 'PMS')
  static readonly ALFRED_GROUP = new SaleType(
    SaleTypeId.ALFRED_GROUP,
    () => $t('Alfred'),
    'ALFREDGRP',
  )
  static readonly CONNECTOR_PAYMENTS = new SaleType(
    SaleTypeId.CONNECTOR_PAYMENTS,
    () => $t('Connector to payment solutions'),
    'CONNPAYGRP',
  )

  private constructor(
    id: SaleTypeId,
    public readonly name: () => string,
    public readonly code: string,
  ) {
    super(id)
  }
}
